// import * as PerformanceReportActions from '../actions/performance-report.actions';
import * as CanHistoryActions from '../actions/can-history.report.actions'

const INITIAL_STATE = {
  entities: [],
  ids: [],
  isLoading: false,
  loadingById: {},
  pathSuccess: null,
};

export default function canHistoryReportReducer(state = INITIAL_STATE, action = '') {
  switch (action.type) {
    case CanHistoryActions.LOAD:
      return {
        ...state,
        isLoading: true,
      };


    case CanHistoryActions.LOAD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        entities: action.data,
        ids: action.data.map((x) => x.tmp_device2),
        pathSuccess: null,
      };

    default:
      return state;
  }
}

export const getEntities = (state) => state?.canHistory.entities;
export const getData = (state) => state.canHistory.entities;
// export const getDataById = (state, id) => state.canHistoryReportReducer.entities[id];
export const getIsLoading = (state) => state?.canHistory.isLoading;
// // aths
// export const getPath = (state) => state.canHistoryReportReducer.pathSuccess;
